import { mapState, mapGetters, mapActions } from 'vuex'

// Auth State
export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
    profileData: (state) => state.profileData,
    role: (state) => state.role,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'forgotPassword',
  'resetPassword',
  'getUserProfile',
  'changePassword',
  'inviteRegister',
  'updateProfile',
])
// Dashboard State

export const dashboardComputed = {
  ...mapState('dashboard', {
    dashboardList: (state) => state.dashboardList,
  }),
}

export const dashboardListMethod = mapActions('dashboard', [
  'fetchDashboardList',
])

// Student State
export const studentComputed = {
  ...mapState('student', {
    studentList: (state) => state.studentList,
  }),
}

export const studentListMethod = mapActions('student', [
  'fetchStudentList',
  'addStudent',
  'addStudentInBulk',
])

// User State
export const userComputed = {
  ...mapState('user', {
    userList: (state) => state.userList,
    adminList: (state) => state.adminList,
  }),
}

export const userListMethod = mapActions('user', [
  'fetchUserList',
  'addUser',
  'fetchAdminList',
  'fetchTeacherList',
  'updateUser',
  'deleteUser',
  'fetchCollegeList',
  'fetchClassList',
  'fetchTrainerList',
  'getZoomUsers',
])

// Login History State
export const loginHistoryComputed = {
  ...mapState('loginhistory', {
    loginHistoryList: (state) => state.loginHistoryList,
  }),
}

export const loginHistoryListMethod = mapActions('loginhistory', [
  'fetchLoginHistoryList',
])

// Course State
export const courseComputed = {
  ...mapState('course', {
    courseList: (state) => state.courseList,
    courseSessionList: (state) => state.courseSessionList,
    calendarEventList: (state) => state.calendarEventList,
    trainingEventList: (state) => state.trainingEventList,
  }),
}

export const courseListMethod = mapActions('course', [
  'fetchCourseList',
  'fetchCourseBatchList',
  'fetchCalendarEventList',
  'addCalendarEvent',
  'updateCalendarEvent',
  'deleteCalendarEvent',
  'fetchTrainingEventList',
  'addTrainingEvent',
  'updateTrainingEvent',
  'deleteTrainingEvent',
  'addCourse',
  'getCourse',
  'updateCourse',
  'deleteCourse',
  'fetchCourseById',
  'addCoursebatch',
  'addCourseContent',
  'deleteCourseContent',
  'fetchCourseSessionList',
  'fileUpload',
  'getVideos',
  'updateCourseSession',
])

// Event State
export const eventComputed = {
  ...mapState('event', {
    eventList: (state) => state.eventList,
  }),
}

export const eventListMethod = mapActions('event', [
  'fetchEventList',
  'addEvent',
  'updateEvent',
  'deleteEvent',
  'getSignedImage',
])

// Blog State
export const blogComputed = {
  ...mapState('blog', {
    blogList: (state) => state.blogList,
  }),
}

export const blogListMethod = mapActions('blog', [
  'fetchBlogList',
  'addBlogData',
  'updateBlog',
  'deleteBlog',
  'getSignedImage',
])

// Category & Sub-category State
export const categoryComputed = {
  ...mapState('category', {
    categoryList: (state) => state.categoryList,
    subCategoryList: (state) => state.subCategoryList,
    allSubCategoryList: (state) => state.allSubCategoryList,
  }),
}

export const categoryListMethod = mapActions('category', [
  'fetchCategoryList',
  'fetchSubCategoryList',
  'fetchAllSubCategoryList',
  'addCategory',
  'updateCategory',
  'deleteCategory',
  'addSubCategory',
  'updateSubCategory',
  'deleteSubCategory',
])

// Report State
export const reportComputed = {
  ...mapState('report', {
    reportList: (state) => state.reportList,
    reportData: (state) => state.reportData,
    reportTableList: (state) => state.reportTableList,
  }),
}

export const reportListMethod = mapActions('report', [
  'fetchReportList',
  'fetchReportDetails',
  'addReportRequest',
  'updateReportRequest',
  'getReportTable',
  'getReportField',
  'getDynamicReportData',
])

// Email Action
export const emailMethod = mapActions('email', ['sendEmail'])

// Common Action
export const commomMethod = mapActions('common', ['fetchSignedURL'])

// Site Config State
export const siteListComputed = {
  ...mapState('siteconfig', {
    siteList: (state) => state.siteList,
  }),
}

export const siteListMethod = mapActions('siteconfig', ['fetchSiteList'])

// Batch
export const batchComputed = {
  ...mapState('batch', {
    batchList: (state) => state.batchList,
  }),
}

export const batchListMethod = mapActions('batch', [
  'fetchBatchList',
  'addBatchData',
  'updateBatchData',
])

// Resource
export const resourceComputed = {
  ...mapState('resource', {
    resourceList: (state) => state.resourceList,
  }),
}

export const resourceListMethod = mapActions('resource', [
  'fetchResourceList',
  'addResourceData',
  'updateResourceData',
  'deleteResourceData',
])

// Assignmnet
export const assignmentComputed = {
  ...mapState('assignment', {
    resourceList: (state) => state.assignmentList,
  }),
}

export const assignmentListMethod = mapActions('assignment', [
  'fetchAssignmentList',
  'addAssignmentData',
  'getAssignmentDataById',
  'updateAssignmentData',
  'deleteAssignmentData',
])

// Meeting State
export const meetingComputed = {
  ...mapState('meeting', {
    meetingList: (state) => state.meetingList,
  }),
}

export const meetingListMethod = mapActions('meeting', [
  'fetchMeetingList',
  'addMeeting',
  'updateToken',
  'generateSignature',
  'updateMeeting',
  'deleteMeeting',
  'getStartUrl',
])

// College
export const collegeComputed = {
  ...mapState('college', {
    collegeList: (state) => state.collegeList,
  }),
}

export const collegeListMethod = mapActions('college', [
  'fetchCollegeList',
  'addCollegeData',
  'updateCollegeData',
  'deleteCollegeData',
])

// College Class
export const collegeClassComputed = {
  ...mapState('collegeClass', {
    collegeClassList: (state) => state.collegeClassList,
  }),
}

export const collegeClassListMethod = mapActions('collegeClass', [
  'fetchCollegeClassList',
  'addCollegeClassData',
  'updateCollegeClassData',
  'deleteCollegeClassData',
])

// Department
export const departmentComputed = {
  ...mapState('department', {
    departmentList: (state) => state.departmentList,
  }),
}

export const departmentListMethod = mapActions('department', [
  'fetchDepartmentList',
  'addDepartment',
  'updateDepartment',
  'deleteDepartment',
])
export const domainListMethod = mapActions('domain', [
  'fetchDomainList',
  'addDomain',
  'updateDomain',
  'deleteDomain',
  'fetchSubDomainList',
  'addSubDomain',
  'updateSubDomain',
  'deleteSubDomain',
])
